import React, { useState } from 'react';
import { faqs, founder } from '../mock';
import { Plus, ArrowUpRight } from 'lucide-react';
import CalendlyButton from './CalendlyButton';

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="relative py-20 md:py-28 bg-paper-soft">
      <div className="squiggle-bg" />
      <div className="max-w-6xl mx-auto px-6 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-start">
          {/* Left: Founder quote */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#143324]/20 bg-[#ece7db] text-[11px] tracking-[0.2em] uppercase text-[#143324] font-body mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#143324]" />
              FAQ
            </div>
            <h2 className="font-serif-display text-[#143324] text-4xl md:text-5xl leading-[1.05] tracking-tight mb-8">
              Your Questions, Answered <em className="italic">Clearly</em>
            </h2>

            <div className="card-soft rounded-2xl p-6 md:p-7">
              <p className="font-serif-display text-[#143324] text-xl md:text-2xl leading-snug italic mb-6">
                &ldquo;{founder.quote}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <img src={founder.image} alt="AJ Tax Consulting mark" className="w-12 h-12 rounded-xl object-contain bg-[#071a36] p-1.5" />
                <div>
                  <p className="text-sm font-body text-[#1c1c1c]">{founder.name}</p>
                </div>
              </div>
            </div>

            <div className="mt-8 flex items-center gap-3 flex-wrap">
              <CalendlyButton className="inline-flex items-center gap-2 btn-primary px-6 py-3 rounded-full text-sm font-body">
                Get Started <ArrowUpRight size={16} />
              </CalendlyButton>
              <a href="#services" className="inline-flex items-center gap-2 btn-outline px-6 py-3 rounded-full text-sm font-body">
                Our Services
              </a>
            </div>
          </div>

          {/* Right: FAQ list */}
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={i}
                  className={`card-soft rounded-2xl transition-all duration-300 ${open ? 'shadow-sm' : ''}`}
                >
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                  >
                    <span className="font-body text-[#143324] text-base md:text-[17px] font-medium">
                      {f.question}
                    </span>
                    <span
                      className={`w-8 h-8 rounded-full bg-[#143324] flex items-center justify-center text-[#f2eee4] shrink-0 transition-transform duration-300 ${
                        open ? 'rotate-45' : ''
                      }`}
                    >
                      <Plus size={16} />
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-6 pb-6 text-[#3d3d3d] text-[14px] leading-relaxed font-body">
                        {f.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
